import testimonial_img_1 from "../../assets/images/testimonial/testimonial-1.jpg"
import testimonial_img_2 from "../../assets/images/testimonial/testimonial-2.jpg"
import testimonial_img_3 from "../../assets/images/testimonial/testimonial-3.jpg"
import testimonial_img_4 from "../../assets/images/about/about-2.jpg"
import testimonial_img_5 from "../../assets/images/testimonial/testimonial-5.jpg"
import testimonial_img_6 from "../../assets/images/about/about-2.jpg"
export const testimonialData = [
    {
        id: 1,
        name: "Payton Nelson",
        position: "Nurse",
        src: testimonial_img_1,
        rating: 5,
        review: `“I took the class a few months ago. Jamie’s concealed carry class was thorough and well taught, even if you are new to firearms. I think anyone could benefit from the class. Not only do you get a range session with some very experienced guys, you also get a very in depth portion of teaching on the legal side of things. Also the prices were very affordable."`
    },
    {
        id: 2,
        name: "Dakota Creppel",
        position: "",
        src: testimonial_img_2,
        rating: 5,
        review: `“I took a CPR class, and it was honestly the best experience! I left feeling far more confident that I would be able to respond properly in an emergency situation, but the instructors ensured that the course was still engaging and fun. We had multiple chances for questions and discussion, and it didn't feel like simply attending a lecture and taking a test. This will absolutely be my go to for future certifications, and I've already recommended the course to others."`
    },
    {
        id: 3,
        name: "Zack Guidroz",
        position: "Law Enforcement",
        src: testimonial_img_3,
        rating: 5,
        review: `“I’ve taken numerous CPR/AED classes. 16 to be exact. This class was by far the best I’ve ever attended. When I left that day I was 100 percent confident I could provide life saving techniques to a person in need. Definitely recommend this course and trainers!!!"`
    },
    {
        id: 4,
        name: "Robin Tisdale",
        position: "Education",
        src: testimonial_img_4,
        rating: 5,
        review: `“My daughter and I took the CPR class with Jamie and Shane. Both were very knowledgeable on every aspect of the training. We had several teenagers in the  class and they took the time to explain indepth how to use each device and how to properly execute each move. We were  comfortable enough to be able to ask questions and go back over anything we weren't sure about. We plan for my youngest daughter and son to take this class with these guys. We highly recommend them."`
    },
    {
        id: 5,
        name: "Drew and Amanda Stanley",
        position: "",
        src: testimonial_img_5,
        rating: 5,
        review: `“My wife and I recently took a firearms class with Jamie Singley at J5 Solutions, and I can honestly say it was one of the best training experiences I’ve had.

Jamie did a great job breaking everything down in a way that made sense, no matter what your skill level is.

The classroom part was clear and to the point  covering essential topics such as firearm safety protocols, handling fundamentals and legal responsibilities. Once we got to the range, Jamie provided a one-on-one feedback and instructions from stance and grip to situational awareness.

What I liked the most was how Jamie was able to blend technical instruction with real life applications.

If you’re looking to get comfortable with a firearm, sharpening your skills, or just want some solid advice, I highly recommend checking out J5 Solutions. Jamie knows his stuff from start to finish."`
    },
    {
        id: 6,
        name: "Robin Tisdale",
        position: " ",
        src: testimonial_img_6,
        rating: 5,
        review: `“My teenage daughters and a few of their friends took the  women's self-defense class with Jamie and Mitch.  This day in age, I think all ladies should have an understanding of how to protect themselves. Mitch was very patient and knew how to explain each move so everyone understood.  He walked everyone through each move and corrected where it was needed so everyone was safe. Jamie helped explained the why behind each move. I highly recommended any lady to take this class. I learned alot just helping and noticed all the girls left there with more confidence than went in with."`
    },

]